import styled from "styled-components";

export const StyledIOSSwitch = styled.input.attrs({ type: "checkbox" })<{
  backgroundColor: string;
}>`
  width: 42px;
  height: 26px;
  padding: 0;
  appearance: none;
  position: relative;
  border-radius: 13px;
  background-color: #cdcdcd;
  transition: background-color 0.5s;
  cursor: pointer;

  &:checked {
    background-color: ${(props) => props.backgroundColor};
    &::before {
      transform: translateX(16px);
      background-color: #fff;
    }
  }

  &:focus-visible::before {
    border: 6px solid #fff;
    background-color: #33cf4d;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    &::before {
      background-color: #bdbdbd;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: #fff;
    transition: transform 0.3s;
    box-sizing: border-box;
  }
`;
